import { Component, Injectable, OnInit } from '@angular/core';
import { ConversationChildTab, ConversationTabList } from './convertsation.const';
import { Router, NavigationEnd } from '@angular/router';
import { getCurrentTab } from './convertsation.const';

@Component({
  selector: 'settings-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.css'],
})
@Injectable()
export class ConversationComponent implements OnInit {
  public currentTab;
  public readonly conversationTabList = ConversationTabList;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
  }

  onChangeTab(tabId: ConversationChildTab) {
    this.currentTab = tabId;
    this.router.navigate([tabId]);
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/conversation.component.ts